import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { DropdownBodyWrapper, DropdownHeaderWrapper } from './wrappers';
import { SecondaryTextXs, Icon, BoldMatchText } from 'atoms';
import internalState from './internalState';
import { ChevronUpSvg, ChevronRight } from 'components/icons';
import { Ml2, FlexCenterJustifyCenterWrapper, GenericWrapper } from 'wrappers';
import { boldMatchCharacters } from 'utils';

export const definition = {
  name: 'CategoryDropdown',
  controller: Controller,
  initialProps: ({ isOpen, searchTerm, category, selectedCategoryId, selectedParentId }) => ({ isOpen, searchTerm, category, selectedCategoryId, selectedParentId }),
  props: internalState,
  elements: [
    {
      wrapper: GenericWrapper,
      name: 'Wrapper',
      ref: ({ dropdownRef }) => dropdownRef ?? null,
      elements: [
        {
          wrapper: DropdownHeaderWrapper,
          name: 'Header',
          isButton: true,
          bindings: ({ isOpen, dropdownRef }) => ({ isOpen, dropdownRef }),
          displayState: ({ category, selectedParentId }) => ({ selected: category.id === selectedParentId }),
          elements: [
            {
              wrapper: FlexCenterJustifyCenterWrapper,
              name: "Wrapper",
              elements: [
                {
                  component: Icon,
                  name: 'ChevronIcon',
                  displayValue: ({ isOpen }) => {
                    if (isOpen) {
                      return ChevronUpSvg({ color: "#04333B", width: 12, height: 12 })
                    }
                    return ChevronRight({ color: "#04333B", width: 20, height: 20 })
                  }
                },
                {
                  component: wrap(BoldMatchText, Ml2),
                  name: 'Text',
                  bindings: ({ }) => ({}),
                  displayValue: ({ category, searchTerm }) => boldMatchCharacters({ text: category.name, match: searchTerm }),
                  
                },
              ]
            },
          ]
        },
        {
          wrapper: DropdownBodyWrapper,
          name: 'Body',
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: DropdownHeaderWrapper,
              name: 'Children',
              isListOf: 'category.children',
              isButton: true,
              bindings: ({ isOpen, child }) => ({ child, isOpen }),
              displayState: ({ child, selectedCategoryId }) => ({ selected: child.id === selectedCategoryId }),
              elements: [
                {
                  component: BoldMatchText,
                  name: 'Children',
                  displayValue: ({ child, searchTerm }) => boldMatchCharacters({ text: child.name, match: searchTerm }),
                }
              ]
            },

          ]
        }
      ]
    }
  ]
};

const CategoryDropdown = ContainerComponent(definition);

export default CategoryDropdown;